import constate from "constate";

import { useGetCompletedWorkplaceSpecificRequirements } from "../api/wrappers/useGetCompletedWorkplaceLevelRequirements";
import { useGetIncompleteWorkplaceSpecificRequirements } from "../api/wrappers/useGetIncompleteWorkplaceLevelRequirements";
import { useGetMandatoryWorkerRequirements } from "../api/wrappers/useGetMandatoryWorkerRequirements";
import { useGetOptionalRequirements } from "../api/wrappers/useGetOptionalRequirements";
import { useGetWorkerLicensesAllowedForDocuments } from "../useGetWorkerLicensesAllowedForDocuments";
import { useDocumentsPageNavigationContext } from "./useNavigation";

function useDocumentsPageApi() {
  const { selectedTab } = useDocumentsPageNavigationContext();

  const { licenses: availableLicenses, isLoaded: areLicensesLoaded } =
    useGetWorkerLicensesAllowedForDocuments();

  const mandatoryRequirementsQuery = useGetMandatoryWorkerRequirements(
    {
      qualifications: availableLicenses,
    },
    { enabled: areLicensesLoaded }
  );

  const completedWorkplaceSpecificRequirementsQuery = useGetCompletedWorkplaceSpecificRequirements(
    {
      qualifications: availableLicenses,
    },
    { enabled: selectedTab === "workplaceSpecific" && areLicensesLoaded }
  );

  const incompleteWorkplaceSpecificRequirementsQuery =
    useGetIncompleteWorkplaceSpecificRequirements(
      {
        qualifications: availableLicenses,
      },
      { enabled: selectedTab === "workplaceSpecific" && areLicensesLoaded }
    );

  const optionalRequirementsQuery = useGetOptionalRequirements(
    {
      qualifications: availableLicenses,
    },
    { enabled: selectedTab === "workplaceSpecific" && areLicensesLoaded }
  );

  return {
    mandatoryRequirementsQuery,
    completedWorkplaceSpecificRequirementsQuery,
    incompleteWorkplaceSpecificRequirementsQuery,
    optionalRequirementsQuery,
    isLoading:
      (mandatoryRequirementsQuery.isLoading && selectedTab === "mandatory") ||
      ((completedWorkplaceSpecificRequirementsQuery.isLoading ||
        incompleteWorkplaceSpecificRequirementsQuery.isLoading ||
        optionalRequirementsQuery.isLoading) &&
        selectedTab === "workplaceSpecific"),
    refetch: async () => {
      if (selectedTab === "mandatory") {
        return await mandatoryRequirementsQuery.refetch();
      }

      await completedWorkplaceSpecificRequirementsQuery.refetch();
      await incompleteWorkplaceSpecificRequirementsQuery.refetch();
      return await optionalRequirementsQuery.refetch();
    },
  };
}

export const [DocumentsPageApiProvider, useDocumentsPageApiContext] = constate(useDocumentsPageApi);
